var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"balloon__container",staticClass:"balloon__container"},[_vm._l((_vm.data),function(b,i){return _c('div',{key:`${_vm.scenario}-${b.year}`,staticClass:"balloon-content",style:({
      left: `${
        (_vm.cwidth / 8) * (2 * _vm.index + 1) -
        (((_vm.maxSizeToScreen * b.value) / _vm.max) * _vm.widthRatio) / 2
      }px`,
    })},[_c('div',{staticClass:"balloon",class:[
        `background-${_vm.color}`,
        `after-${_vm.color}`,
        `before-${_vm.color}`,
        `balloon-${_vm.index}`,
        `balloon-${_vm.index}-${i}`,
        { popped: _vm.index === 0 && i === 3 },
      ],style:({
        width: `${((_vm.maxSizeToScreen * b.value) / _vm.max) * _vm.widthRatio}px`,
        height: `${(_vm.maxSizeToScreen * b.value) / _vm.max}px`,
      })},[(_vm.showLabel && b.show)?_c('div',{staticClass:"labels",class:[`label-${_vm.index}-${i}`]},[(_vm.index === 0 && i === 0)?_c('p',{staticClass:"f-ui-2-bold"},[_vm._v("Emissions")]):_vm._e(),(b.nze)?_c('p',{staticClass:"f-ui-2-bold"},[_vm._v("Net Zero 2050")]):_vm._e(),(!b.nze)?_c('p',[_vm._v(" "+_vm._s(b.value)),(_vm.index === 0 && i === 0)?_c('span',[_vm._v(" GtCO2")]):_vm._e()]):_vm._e()]):_vm._e(),(_vm.showLabel && _vm.index === 1)?_c('div',{staticClass:"labels",class:[`label-${_vm.index}-${i}`]},[_c('p',{staticClass:"f-ui-2-bold",class:[`label-years-${i}`]},[_vm._v(_vm._s(b.year))])]):_vm._e()])])}),_c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"string",class:`string-${_vm.index}`,style:({
        bottom: `${_vm.siblingHeight}px`,
        left: `${(_vm.cwidth / 8) * (2 * _vm.index + 1)}px`,
      })})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }